import React from 'react';
import { Spinner } from '@iq/react-components';

const Loader = ({ text = '', overlay = false, height, children }) => (
  <div
    data-testid="loader-component"
    className={`${overlay ? 'overlay' : 'inline'} loader-component`}
    style={{ minHeight: height === undefined ? 'none' : height }}
    aria-busy="true"
  >
    <div
      data-testid="loader"
      className="loader"
    >
      <Spinner />
    </div>
    <output
      data-testid="loader-text"
      className="loader-text"
    >
      {children || text}
    </output>
  </div>
);

export default React.memo(Loader);
